import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CADIntegrationAddOnApiModel } from '../../../api-models';
import { AddOnService } from '../../abstractions';

@Injectable()
export class CadIntegrationAddOnService extends AddOnService<CADIntegrationAddOnApiModel> {
  public readonly prefix = 'cad';

  public activate(): Observable<CADIntegrationAddOnApiModel> {
    return this.http.post<CADIntegrationAddOnApiModel>(`${this.apiUrl}${this.prefix}/activate`);
  }

  public deactivate(): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}${this.prefix}/deactivate`);
  }
}
